import { RootState } from "@/store/store";
import { selectedResourcesResourceTypeByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesResourceTypeByMasterIdSelector";
import { liveUsageMgmtAccountsVisibilitiesByResourceTypeSelector } from "@/store/live-usage-mgmt/selectors/accounts-data/liveUsageMgmtAccountsVisibilitiesByResourceTypeSelector";
import { getResourceCleanActionOptions } from "@/utils/clean-options";
import { ResourceType } from "@/services/cloudchipr.api";

export const liveUsageResourceActionOptionsByVisibilitySelector = (
  state: RootState,
  masterGridId: string,
  masterResourceType: ResourceType,
) => {
  const selectedResourcesResourceType =
    selectedResourcesResourceTypeByMasterIdSelector(state, masterGridId);

  const resourceType = selectedResourcesResourceType ?? masterResourceType;

  const visibility = liveUsageMgmtAccountsVisibilitiesByResourceTypeSelector(
    state,
    resourceType,
  );

  if (!visibility?.actions) {
    return null;
  }

  return getResourceCleanActionOptions(resourceType).filter((option) => {
    return visibility?.actions?.[option.value] !== null;
  });
};
